import Image, { ImageProps } from 'next/image'
import React, { FC } from 'react'

import '@/components/Image/InviewImage/InvewImage.scss'

export type SpImage = {
  spSrc?: string | null
  spWidth?: number | null
  spHeight?: number | null
}

export type PictureProps = ImageProps &
  SpImage & {
    className?: string
    pictureClassName?: string
    style?: React.CSSProperties | {}
    pictureStyle?: React.CSSProperties | {}
    animationRef?: React.Ref<HTMLPictureElement> | null
    children?: React.ReactNode
  }

const Picture: FC<PictureProps> = ({
  src,
  width,
  height,
  alt,
  spSrc = null,
  spWidth = null,
  spHeight = null,
  style = {},
  pictureStyle = {},
  pictureClassName = '',
  className = '',
  quality = 75,
  animationRef = null,
  priority = false,
  children = <></>,
}) => {
  return (
    <picture {...(animationRef != null ? { ref: animationRef } : {})} style={pictureStyle} className={pictureClassName}>
      {spSrc != null && spWidth != null && spHeight != null && (
        <source media="(max-width: 900px)" srcSet={spSrc} width={spWidth} height={spHeight} />
      )}
      <Image
        src={src}
        width={width}
        height={height}
        alt={alt}
        className={className}
        style={style}
        quality={quality}
        priority={priority}
        sizes={`(max-width:900px) 50vw,100vw`}
      />
      {children}
    </picture>
  )
}

export default Picture
